import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { OrderDetailsProvider } from './context/OrderDetailsContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
   <OrderDetailsProvider>
      <App />
   </OrderDetailsProvider>
);

